const comments = [
  {
    id: 1,
    name: '吃瓜不嫌事大',
    avatarBg: 'bg-primary-100 text-primary-600',
    time: '2小时前',
    content: '这个瓜保熟吗？看了一圈感觉这次爆料应该是有实锤的，那个酒店照片角度和光线都很真实，不像P的。坐等后续！',
    likes: 2836,
  },
  {
    id: 2,
    name: '娱乐圈纪检委',
    avatarBg: 'bg-accent-100 text-accent-600',
    time: '3小时前',
    content: '终于有人扒这个了！我之前就在朋友圈看到过一些蛛丝马迹，当时就觉得不对劲，现在果然被爆出来了。',
    likes: 1952,
  },
  {
    id: 3,
    name: '理性吃瓜选手',
    avatarBg: 'bg-secondary-100 text-secondary-600',
    time: '4小时前',
    content: '建议大家理性看待，不要急着站队。等双方都回应了再做判断，现在信息还不够全面。不过爆瓜网的整理确实比较清晰。',
    likes: 1247,
  },
  {
    id: 4,
    name: '深夜吃瓜人',
    avatarBg: 'bg-primary-100 text-primary-600',
    time: '5小时前',
    content: '大半夜的又被瓜炸醒了！这个爆料信息量太大了，我得好好消化一下。感谢爆瓜网深夜还在更新，真爱了！',
    likes: 989,
  },
  {
    id: 5,
    name: '资深瓜农老王',
    avatarBg: 'bg-accent-100 text-accent-600',
    time: '6小时前',
    content: '作为一个吃了十年瓜的老观众，我必须说爆瓜网的质量确实在提升。以前都是搬运，现在开始有独家的整理和分析视角了，继续加油。',
    likes: 756,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium mb-3">
            <i className="ri-chat-1-line"></i>
            瓜友热评
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            瓜友热评
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            百万吃瓜群众的真实声音，看看大家都在聊什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {comments.slice(0, 3).map((comment) => (
            <div key={comment.id} className="bg-background-100 rounded-2xl p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-heading font-bold text-sm ${comment.avatarBg}`}>
                  {comment.name[0]}
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i> {comment.likes.toLocaleString()}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-3-line"></i> 回复
                </span>
              </div>
            </div>
          ))}
          {comments.slice(3).map((comment) => (
            <div key={comment.id} className="bg-background-100 rounded-2xl p-6 border border-background-200/70 hidden lg:block">
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-heading font-bold text-sm ${comment.avatarBg}`}>
                  {comment.name[0]}
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-500">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i> {comment.likes.toLocaleString()}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-3-line"></i> 回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}